/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiTagDefinitionFromJSON, StreemApiTagDefinitionToJSON, } from './';
export function StreemApiSaveTagDefinitionResponseFromJSON(json) {
    return StreemApiSaveTagDefinitionResponseFromJSONTyped(json, false);
}
export function StreemApiSaveTagDefinitionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tag': !exists(json, 'tag') ? undefined : StreemApiTagDefinitionFromJSON(json['tag']),
    };
}
export function StreemApiSaveTagDefinitionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tag': StreemApiTagDefinitionToJSON(value.tag),
    };
}
//# sourceMappingURL=StreemApiSaveTagDefinitionResponse.js.map